// extracted by mini-css-extract-plugin
module.exports = {"cursor-pointer":"TagsFilter-0081646b-scss"};